const devPortalConstant = {
  SET_LOGGED_IN_USER: "SET_LOGGED_IN_USER",
  SET_USER_REDIRECT: "SET_USER_REDIRECT",
  SET_WEBHOOK_APP: "SET_WEBHOOK_APP",
  CLEAR_WEBHOOK_APP: "CLEAR_WEBHOOK_APP",
  SET_OUATH_APP: "SET_OUATH_APP",
  SET_IPARAM_APP: "SET_IPARAM_APP",
  SET_EVENT_FIELDS: "SET_EVENT_FIELDS",
  SET_WHITELISTED_DOMAINS: "SET_WHITELISTED_DOMAINS",
  SET_DEPENDENCIES: "SET_DEPENDENCIES",
  SET_APP_VALIDATION: "SET_APP_VALIDATION",
  SET_CURRENT_APP: "SET_CURRENT_APP",
  CLEAR_CURRENT_APP: "CLEAR_CURRENT_APP",
  SET_TOOLTIP_VALUE: 'SET_TOOLTIP_VALUE',
  UPDATE_SETTINGS: 'UPDATE_SETTINGS',
  SET_SIMULATE_CODE: 'SET_SIMULATE_CODE'
};

export default devPortalConstant;
